import { IMcpResourceDisplay } from '@/bundles/Roles/types';

export const PREDEFINED_MCP_ROLE_NAMES = ['mcp_readonly', 'mcp_full'];

export const MCP_RESOURCE_ORDER = [
  'properties',
  'availabilities',
  'occupiers',
  'comparables',
  'pipelines',
  'contacts',
  'companies',
  'tasks',
  'activities',
  'sequences',
  'requirements',
  'notes',
  'attachments',
  'leases',
  'reporting',
  'saved_sets',
  'eblasts',
  // Last on purpose: it is the only bulk-write resource, and read and write
  // mean very different things for it — read is the CSV column contract, write
  // stages and processes whole files. Append new resources ABOVE this line.
  'imports',
];

export const MCP_RESOURCE_DISPLAY: Record<string, IMcpResourceDisplay> = {
  properties: { label: 'Property', description: 'Listings, addresses, statuses', icon: 'mdi-home' },
  availabilities: { label: 'Availability', description: 'Available spaces & listings', icon: 'mdi-map-marker-radius' },
  occupiers: { label: 'Occupier', description: 'Tenants and space occupiers', icon: 'mdi-account-group' },
  comparables: { label: 'Comparable', description: 'Sale & lease comps', icon: 'mdi-compare' },
  pipelines: { label: 'Pipeline', description: 'In-progress deals & commissions', icon: 'mdi-chart-timeline-variant' },
  contacts: { label: 'Contact', description: 'Leads, sellers, buyers', icon: 'mdi-account' },
  companies: { label: 'Company', description: 'Brokerages, firms, organizations', icon: 'mdi-office-building' },
  tasks: { label: 'Task', description: 'Assignments, due dates', icon: 'mdi-check-circle' },
  activities: { label: 'Activity', description: 'Calls, emails, meetings', icon: 'mdi-timeline-text' },
  sequences: { label: 'Sequence', description: 'Automated outreach steps', icon: 'mdi-sync' },
  requirements: { label: 'Requirement', description: 'Buyer/tenant requirements', icon: 'mdi-clipboard-list' },
  notes: { label: 'Note', description: 'Notes attached to records', icon: 'mdi-note-text' },
  attachments: { label: 'Attachment', description: 'Files attached to records', icon: 'mdi-paperclip' },
  leases: { label: 'Lease', description: 'Lease document ingestion', icon: 'mdi-file-document-outline' },
  reporting: { label: 'Reporting', description: 'Dashboards and analytics', icon: 'mdi-chart-box' },
  saved_sets: { label: 'Saved Set', description: 'Saved lists of records', icon: 'mdi-bookmark-multiple' },
  // Read-only: per-recipient opens and clicks. The MCP cannot create or send eblasts.
  eblasts: { label: 'Eblast', description: 'Recipient opens & clicks', icon: 'mdi-email-open-multiple' },
  imports: { label: 'Import', description: 'Bulk CSV import of records', icon: 'mdi-database-import' },
};
